// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Toastr, Button, Input } from "@revvsales/components";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RecordVideoComponent from "./RecordVideoComponent";

import { documentAttachmentService } from "../../../actions/DocumentActions/services";

import {
  acceptanceApprovalStatusCheck,
  fetchDocRecipientListAction,
} from "../../../actions/DocumentActions";
// Components Imports
import { GlobalUtils } from "../../../utils";

const { isChromeBrowser, isMobileAndroidBrowser } = GlobalUtils;

class RecordVideoPopupRecipient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadVideoFile: "",
      // isRecorded: false,
      checkedAcceptDoc: false,
      videoThumbnail: "",
      btnLoader: false,
      footerRerecordText: "Discard and re-record",
      currentVideoUrl: "",
    };
  }

  componentDidMount() {
    if (window.innerWidth < 600) {
      this.setState({ footerRerecordText: "Re-record" });
    }
  }

  _closePopup = () => {
    this.props.toggleModalPopUp("showRecordVideoPopup", false);
  };

  _updateState = obj => {
    this.setState({
      ...obj,
    });
  };

  _resetAttachVideo = () => {
    this.setState({
      uploadVideoFile: "",
      currentVideoUrl: "",
    });
  };

  _handleCheckBox = val => {
    this.setState({
      checkedAcceptDoc: !val,
    });
  };

  _acceptVideo = () => {
    this.setState({ btnLoader: true });
    documentAttachmentService(
      this.props.docID,
      this.state.uploadVideoFile,
      this.state.videoThumbnail,
      this.props.sharingHash,
    )
      .then(res => {
        this.props
          .acceptanceApprovalStatusCheck(
            this.props.docID,
            this.props.sharingHash,
            this.props.view,
            res.Attachment.ID,
          )
          .then(() => {
            this.props.togglePopUp(
              "acceptanceApproveRejectConfirmation",
              false,
            );
            if (!this.props.isSharing) {
              this.props.fetchDocRecipientListAction(this.props.docID);
            }
            if (this.props.view === "accept") {
              if (this.props.isSharing) {
                this.props.getUpdatedShareddata();
              }
              this.props.updateMultipleState({
                acceptanceApproveRejectConfirmation: false,
                acceptAndRejectBtn: false,
                showRecordVideoPopup: false,
                docAcceptanceConfirmationPopup: true,
              });
            } else if (this.props.view === "reject") {
              if (this.props.isSharing) {
                this.props.getUpdatedShareddata();
              }
              this.props.updateMultipleState({
                acceptanceApproveRejectConfirmation: false,
                acceptAndRejectBtn: false,
                showRecordVideoPopup: false,
                docRejecteConfirmationPopup: true,
              });
            }
          });
      })
      .catch(() => {
        this.setState({ btnLoader: false });
        Toastr.showToastr({
          type: "failure",
          message: `Oops! Couldn't ${
            this.props.view
          } document. Please try again.`,
          timeout: 3000,
        });
        this.props.updateMultipleState({
          acceptanceApproveRejectConfirmation: false,
          acceptAndRejectBtn: false,
        });
      });
  };

  _renderModalFooter = () => {
    if (!this.props.showRecordVideoPopupForRecording) {
      return (
        <div className="modal-footer">
          <Button
            id="recordvideo-close-btn"
            className="btn btn-primary modal-footer-btn submit-btn"
            data-test="recordvideo-close-btn-recipient-done"
            onClick={this._closePopup}>
            Done
          </Button>
        </div>
      );
    }
    if (this.state.uploadVideoFile || this.state.currentVideoUrl) {
      return (
        <div className="modal-footer">
          <Button
            id="recordvideo-back-btn"
            className="btn btn-transparent modal-footer-btn submit-btn"
            data-test="recordvideo-back-btn"
            onClick={this._resetAttachVideo}>
            {this.state.footerRerecordText}
          </Button>
          <Button
            isLoading={this.state.btnLoader}
            disabled={!this.state.checkedAcceptDoc}
            id="recordvideo-close-btn"
            className={`${
              this.props.view === "reject" ? "reject-document" : ""
            }`}
            data-test="recordvideo-close-btn-recipient"
            onClick={this._acceptVideo}>
            {this.props.view === "accept" ? "Accept" : "Reject"} Document
          </Button>
        </div>
      );
    }
    return null;
  };

  _renderHeading = () => {
    if (!this.props.showRecordVideoPopupForRecording) {
      return `${this.props.createdBy.name} has sent you a video message`;
    }
    if (!this.state.uploadVideoFile) {
      return "Record your video here";
    }
    return this.props.view === "accept"
      ? "Accept this document with video KYC"
      : "Reject this document with video KYC";
  };

  _renderSubHeading = () => {
    if (!this.props.showRecordVideoPopupForRecording) {
      return `Click the play button below to view the message. You can access the video any time from the 📎${" "}Attachments tab.`;
    }
    if (this.state.uploadVideoFile) {
      return `If you're happy with your recording, check the box to confirm your ${
        this.props.view === "accept" ? "acceptance" : "rejectance"
      } and click ${
        this.props.view === "accept" ? "Accept document." : "Reject Document."
      } If not, you can discard this video and re-record it.`;
    }
    return "Click the record button below to start recording. You can re-record it as many times as you want.";
  };

  render() {
    const isChrome = isChromeBrowser();
    const isMobile = isMobileAndroidBrowser();
    return (
      <Modal
        open
        onClose={this._closePopup}
        center
        closeOnOverlayClick={false}
        classNames={{
          modal: "custom-modal-recordvideo",
        }}>
        <div className="recordvideopopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div
            className="modal-heading"
            data-test="recordvideo-modal-heading-recipient">
            {this._renderHeading()}
          </div>
          <div className="recordvideo-popup-content-section">
            <div className="recordvideo-popup-info-list">
              <p className="recordvideo-subhead-text">
                {this._renderSubHeading()}
              </p>
            </div>
            {(!isChrome || !isMobile) && (
              <div className="attach-video-main">
                <span>
                  <FontAwesomeIcon icon={["fas", "info-circle"]} color="red" />
                </span>
                <p className="attachvideo-text">
                  {`Video playback will soon be available on this browser. For
                  now, please try this feature on Google Chrome${
                    !isMobile ? " desktop version." : "."
                  }`}
                </p>
              </div>
            )}
            <div className="recordvideo-popup-info-list">
              {!this.props.showRecordVideoPopupForRecording && (
                <video
                  src={this.props.senderAttachment.Link}
                  controls
                  width={480}
                  height={360}>
                  <track
                    kind="captions"
                    srcLang="en"
                    label="english_captions"
                  />
                </video>
              )}
              {this.props.showRecordVideoPopupForRecording && (
                <RecordVideoComponent
                  docID={this.props.docID}
                  sharingHash={this.props.sharingHash}
                  updateState={this._updateState}
                  videoFileAvailable={this.state.uploadVideoFile}
                  currentVideoUrl={this.state.currentVideoUrl}
                  fileName={`${
                    this.props.sharedUser
                      ? this.props.sharedUser.name
                      : this.props.userDetails.user.name
                  }`}
                />
              )}
            </div>
            {this.props.showRecordVideoPopupForRecording &&
              this.state.uploadVideoFile && (
                <div className="recordvideo-popup-info-list">
                  <Input
                    checked={this.state.checkedAcceptDoc}
                    name="role"
                    onChange={() =>
                      this._handleCheckBox(this.state.checkedAcceptDoc)
                    }
                    type="checkbox"
                    data-test="check-accept-document"
                    value={`I accept this document - ${this.props.name}`}
                  />{" "}
                  {`I ${
                    this.props.view === "accept" ? "accept" : "reject"
                  } this document - ${this.props.name}`}
                </div>
              )}
          </div>
          {/* ----------- Modal Footer Section ----------- */}
          {this._renderModalFooter()}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID, created_by: createdBy, name },
  } = state.DocumentStore;
  const { sharedUser } = state.SharedDocument;
  return {
    docID,
    createdBy,
    sharedUser,
    name,
  };
};

const mapDispatchToProps = {
  acceptanceApprovalStatusCheck,
  fetchDocRecipientListAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecordVideoPopupRecipient);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/RecordVideoPopup/RecordVideoPopupRecipient.js